import React, { useEffect } from "react";
import {
  Box,
  Fab,
  Button,
  Grid,
  TextField,
  Typography,
  FormControl,
  Modal,
} from "@mui/material";
import { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import PoprchModal from "../payment/popSearch";
import { ToDate } from "../../common/toDate";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { addVendor, updateVendor } from "./vendorRegistrationApi.js";
import {
  addNewVendor,
  updateExistingVendor,
} from "./vendorRegistrationCustomApiHandler.js";
import { swalAlertPopProps } from "../../utils/commonUtils";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { ModalHeader } from "../../common/modalHeader.jsx";

function AddVendorForm({ open, setOpen, modalData, getVendorsList }) {
  const [formData, setFormData] = useState({});
  const [dateValue, setDateValue] = useState(dayjs());

  const struct = {
    id: 0,
    vendorId: "",
    vendorName: "",
    pan: "",
    gstRegistrationNumber: "",
    cinOrShopActNumber: "",
    companyAddress: "",
    phoneNumber: "",
    mobileNumber: "",
    alternateMobileNumber: "",
    bankAccountNumber: "",
    bankName: "",
    ifscCode: "",
    branchAddress: "",
    area: "",
    city: "",
    vendorInfoInShort: "",
    // vendorRegistrationDate: "",
    emailId: "",
    emailId1: "",
    emailId2: "",
    upiId: "",
  };

  useEffect(() => {
    setFormData({ ...struct });
  }, []);

  const handleSubmit = async () => {

      if (!formData.companyAddress || !formData.mobileNumber) {
        Swal.fire({
          title: "Please enter both Company Address and Mobile Number",
          icon: "error",
          ...swalAlertPopProps,
        });
        return;
      }
    if (!modalData?.id) {
      await addNewVendor(addVendor, formData, (res) => {
        if (res?.data?.succeeded) {
          Swal.fire({
            title: "Vendor Added Successfully",
            icon: "success",

            ...swalAlertPopProps,
          });
        } else {
          Swal.fire({
            title: res?.data?.message,
            icon: "error",

            ...swalAlertPopProps,
          });
        }
        setFormData({ ...struct });
      });
    } else {
      await updateExistingVendor(updateVendor, formData, (res) => {
        if (res?.data?.succeeded) {
          Swal.fire({
            title: "Vendor Updated Successfully",
            icon: "success",

            ...swalAlertPopProps,
          });
        } else {
          Swal.fire({
            title: res?.data?.message,
            icon: "error",

            ...swalAlertPopProps,
          });
        }
        setFormData({ ...struct });
      });
    }

    getVendorsList();
    setOpen(false);
  };

  const onClose = () => {
    setFormData({ ...struct });
    setOpen(false);
  };

  useEffect(() => {
    if (open === true && modalData?.id) {
      setFormData({
        ...struct,
        ...modalData,
      });
    } else if (open === true) {
      setFormData({ ...struct });
    }
  }, [open, modalData]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth="xs"
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "77%", md: "65%", lg: "40%", xl: "40%" },
          overflowY: "auto",
          height: { sm: "90vh", xs: "80vh" },
          position: "absolute",
          borderRadius: "10px",
          left: { xs: "2%", sm: "18%", md: "25%", lg: "30%", xl: "30%" },
          top: { sm: "8%", xs: "3%" },
        }}
      >
        <ModalHeader
          title={"Vendors Registration"}
          onClose={(data) => {
            setFormData({ ...struct });
            setOpen(data);
          }}
        />
        <Grid container sx={{ position: "relative", p: 2 }}>
          <Grid container item xs={12} spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={3}>
              <FormControl fullWidth>
                <TextField
                  label="Vendor Id :"
                  name="vendorId"
                  size="small"
                  value={formData.vendorId}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      vendorId: Number(e.target.value),
                    });
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 10);
                  }}
                  required
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  InputProps={{ classes: { input: "mulish" } }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <TextField
                  label="Vendor Name :"
                  name="vendorName"
                  size="small"
                  value={formData.vendorName}
                  onChange={(e) => {
                    setFormData({ ...formData, vendorName: e.target.value });
                  }}
                  onInput={(e) => {
                    e.target.value =
                      e.target.value.charAt(0).toUpperCase() +
                      e.target.value.slice(1);
                  }}
                  required
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  InputProps={{ classes: { input: "mulish" } }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormControl fullWidth>
                <TextField
                  label="PAN Number :"
                  name="pan"
                  size="small"
                  value={formData.pan}
                  onChange={(e) => {
                    setFormData({ ...formData, pan: e.target.value });
                  }}
                  onInput={(e) => {
                    let value = e.target.value.toUpperCase();
                    const regex = /^[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}$/; // Allow partial input
                    if (!regex.test(value)) {
                      e.target.value = value.slice(0, -1); // Remove the last character if invalid
                    } else {
                      e.target.value = value; // Keep the valid input
                    }
                  }}
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  InputProps={{ classes: { input: "mulish" } }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={7}>
              <FormControl fullWidth>
                <TextField
                  label="GST Registration Number :"
                  size="small"
                  name="gstRegistrationNumber"
                  value={formData.gstRegistrationNumber}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      gstRegistrationNumber: e.target.value,
                    });
                  }}
                  onInput={(e) => {
                    let value = e.target.value.toUpperCase();
                    const regex =
                      /^[0-9]{0,2}[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}[1-9A-Z]{0,1}[Z]{0,1}[0-9A-Z]{0,1}$/;
                    if (!regex.test(value)) {
                      e.target.value = value.slice(0, -1);
                    } else {
                      e.target.value = value;
                    }
                  }}
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  InputProps={{ classes: { input: "mulish" } }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={5}>
              <FormControl fullWidth>
                <TextField
                  label="CIN / Shop ACT Number :"
                  size="small"
                  name="cinOrShopActNumber"
                  value={formData.cinOrShopActNumber}
                  onChange={(e) => {
                    if (e.target.value.length <= 20) {
                      setFormData({
                        ...formData,
                        cinOrShopActNumber: e.target.value,
                      });
                    }
                  }}
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  InputProps={{ classes: { input: "mulish" } }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={8} sx={{ mb: 2 }}>
            <FormControl fullWidth>
              <TextField
                label="Company Address :"
                size="small"
                name="companyAddress"
                value={formData.companyAddress}
                onChange={(e) => {
                  setFormData({ ...formData, companyAddress: e.target.value });
                }}
                onInput={(e) => {
                  e.target.value =
                    e.target.value.charAt(0).toUpperCase() +
                    e.target.value.slice(1);
                }}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                required
                InputProps={{ classes: { input: "mulish" } }}
              />
            </FormControl>
          </Grid>
          <Grid container item xs={12} spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={4} sx={{}}>
              <FormControl fullWidth>
                <TextField
                  label="Phone Number :"
                  name="phoneNumber"
                  size="small"
                  value={formData.phoneNumber}
                  onChange={(e) => {
                    setFormData({ ...formData, phoneNumber: e.target.value });
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 10);
                  }}
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  InputProps={{ classes: { input: "mulish" } }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} sx={{}}>
              <FormControl fullWidth>
                <TextField
                  label="Mobile Number :"
                  name="mobileNumber"
                  size="small"
                  value={formData.mobileNumber}
                  onChange={(e) => {
                    setFormData({ ...formData, mobileNumber: e.target.value });
                  }}
                  required
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 10);
                  }}
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  InputProps={{ classes: { input: "mulish" } }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} sx={{}}>
              <FormControl fullWidth>
                <TextField
                  label="Alternate Mobile Number :"
                  name="alternateMobileNumber"
                  size="small"
                  value={formData.alternateMobileNumber}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      alternateMobileNumber: e.target.value,
                    });
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 10);
                  }}
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "12px", md: "14px" },
                      paddingX: "7px",
                    },
                  }}
                  InputProps={{ classes: { input: "mulish" } }}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container item xs={12} spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={4} sx={{}}>
              <FormControl fullWidth>
                <TextField
                  label="Area :"
                  name="area"
                  size="small"
                  value={formData.area}
                  onChange={(e) => {
                    setFormData({ ...formData, area: e.target.value });
                  }}
                  onInput={(e) => {
                    e.target.value =
                      e.target.value.charAt(0).toUpperCase() +
                      e.target.value.slice(1);
                  }}
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  InputProps={{ classes: { input: "mulish" } }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} sx={{}}>
              <FormControl fullWidth>
                <TextField
                  label="City :"
                  name="city"
                  size="small"
                  value={formData.city}
                  onChange={(e) => {
                    setFormData({ ...formData, city: e.target.value });
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\b\w/g, (char) =>
                      char.toUpperCase()
                    );
                  }}
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  InputProps={{ classes: { input: "mulish" } }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} sx={{}}>
              <FormControl fullWidth>
                <TextField
                  label="UPI Id :"
                  name="upiId"
                  size="small"
                  value={formData.upiId}
                  onChange={(e) => {
                    setFormData({ ...formData, upiId: e.target.value });
                  }}
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  InputProps={{ classes: { input: "mulish" } }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={4} sx={{}}>
              <FormControl fullWidth>
                <TextField
                  label="Email Id 1 :"
                  name="emailId"
                  size="small"
                  value={formData.emailId}
                  onChange={(e) => {
                    setFormData({ ...formData, emailId: e.target.value });
                  }}
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  InputProps={{ classes: { input: "mulish" } }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} sx={{}}>
              <FormControl fullWidth>
                <TextField
                  label="Email ID 2 :"
                  name="emailId1"
                  size="small"
                  value={formData.emailId1}
                  onChange={(e) => {
                    setFormData({ ...formData, emailId1: e.target.value });
                  }}
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  InputProps={{ classes: { input: "mulish" } }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4} sx={{}}>
              <FormControl fullWidth>
                <TextField
                  label="Email ID 3:"
                  name="emailId2"
                  size="small"
                  value={formData.emailId2}
                  onChange={(e) => {
                    setFormData({ ...formData, emailId2: e.target.value });
                  }}
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  InputProps={{ classes: { input: "mulish" } }}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid item xs={12} sx={{ mb: 2 }}>
            <FormControl fullWidth>
              <TextField
                label="Vendor Info In Short :"
                name="vendorInfoInShort"
                size="small"
                value={formData.vendorInfoInShort}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    vendorInfoInShort: e.target.value,
                  });
                }}
                InputLabelProps={{
                  className: "mulish",
                  sx: {
                    color: "#545454",
                    fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingX: "7px",
                  },
                }}
                InputProps={{ classes: { input: "mulish" } }}
              />
            </FormControl>
          </Grid>

          <Box
            sx={{
              border: "1.5px solid #01008B",
              borderRadius: "8px",
              p: 2,
              mt: 2,
              position: "relative",
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                position: "absolute",
                top: "-12px",
                left: "12px",
                backgroundColor: "#fff",
                px: 1,
                fontWeight: 600,
                color: "#01008B",
              }}
            >
              Bank Details :
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={5}>
                <FormControl fullWidth>
                  <TextField
                    label="Bank Account Number :"
                    name="bankAccountNumber"
                    size="small"
                    value={formData.bankAccountNumber}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        bankAccountNumber: e.target.value,
                      })
                    }
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    InputProps={{ classes: { input: "mulish" } }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={7}>
                <FormControl fullWidth>
                  <TextField
                    label="Bank Name :"
                    name="bankName"
                    size="small"
                    value={formData.bankName}
                    onChange={(e) =>
                      setFormData({ ...formData, bankName: e.target.value })
                    }
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/\b\w/g, (char) =>
                        char.toUpperCase()
                      );
                    }}
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    InputProps={{ classes: { input: "mulish" } }}
                  />
                </FormControl>
              </Grid>

              {/* <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <TextField
                    label="Bank Branch :"
                    name="bankBranch"
                    size="small"
                    value={formData.bankBranch}
                    onChange={(e) =>
                      setFormData({ ...formData, bankBranch: e.target.value })
                    }
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/\b\w/g, (char) =>
                        char.toUpperCase()
                      );
                    }}
                     InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                    InputProps={{ classes: { input: "mulish" } }}
                  />
                </FormControl>
              </Grid> */}

              <Grid item xs={12} sm={7}>
                <FormControl fullWidth>
                  <TextField
                    label="Branch Address :"
                    name="branchAddress"
                    size="small"
                    value={formData.branchAddress}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        branchAddress: e.target.value,
                      })
                    }
                    onInput={(e) => {
                      e.target.value =
                        e.target.value.charAt(0).toUpperCase() +
                        e.target.value.slice(1);
                    }}
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    InputProps={{ classes: { input: "mulish" } }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={5}>
                <FormControl fullWidth>
                  <TextField
                    label="IFSC Code of the Branch :"
                    name="ifscCode"
                    size="small"
                    value={formData.ifscCode}
                    onChange={(e) =>
                      setFormData({ ...formData, ifscCode: e.target.value })
                    }
                    onInput={(e) => {
                      e.target.value = e.target.value.toUpperCase();
                    }}
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    InputProps={{ classes: { input: "mulish" } }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          {/* <Grid item xs={12} sm={4} sx={{ p: "14px" }}>
            <FormControl fullWidth>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Vendor Registration Date"
                  value={
                    formData.vendorRegistrationDate
                      ? dayjs(formData.vendorRegistrationDate)
                      : null
                  }
                  onChange={(newValue) => {
                    console.log(newValue);
                    // let formattedDate = dayjs(newValue).format("YYYY-MM-DD");
                    setFormData({
                      ...formData,
                      vendorRegistrationDate: newValue,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                       InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                      InputProps={{ classes: { input: "mulish" } }}
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>
          </Grid> */}
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            p: "14px",
            borderTop: "1px solid black",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            onClick={handleSubmit}
            sx={{
              width: "80%",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
            variant="contained"
          >
            {modalData?.id ? "Update" : "Save"}
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
}

export default AddVendorForm;
